import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/exposure_new.gif'


const _hoisted_1 = { class: "pageBack" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "banner_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "productYp_exposure" }
const _hoisted_4 = { class: "per_pro" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"color":"#6D7174","float":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "",
      "left-text": "",
      "right-text": "举报",
      onClickLeft: _ctx.onClickLeft,
      onClickRight: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goUrl())),
      class: "title"
    }, null, 8, ["onClickLeft"]),
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dhInfoList, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: ($event: any) => (_ctx.jumpInfo(item))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.feedbackTitle), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.feedbackTime), 1)
          ], 8, _hoisted_5)
        ])
      ]))
    }), 256))
  ]))
}